"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _default = exports.default = _styledComponents.default.div.withConfig({
  componentId: "sc-qtl69o-0"
})(["display:none;@media ", "{margin-left:24px;display:flex;;}"], _responsive.default.lg);